import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';

import MesDemandes from './MesDemandes';
import DemandeConge from './DemandeConge';
import SoldeConges from './SoldeConges';

/**
 * Destination « Mes congés » de l'espace employé.
 *
 * Réunit ce qui va ensemble : la liste de ses demandes et le dépôt d'une
 * nouvelle. Le formulaire ne se monte qu'à la demande — il appelle C10 pour
 * les types d'absence, et une destination ne paie que ce qu'elle affiche.
 *
 * `demandesDeposees` est le compteur poussé à la liste après un dépôt réussi :
 * sans lui, l'employé envoie sa demande et l'écran ne bouge pas.
 */
function MesConges() {
  const { t } = useTranslation();
  const [demandeOuverte, setDemandeOuverte] = useState(false);
  const [demandesDeposees, setDemandesDeposees] = useState(0);

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* L'action principale se pose en haut à droite, comme sur les autres
          écrans de liste du portail (cf. Employee/Profil/Documents) : on ne va
          pas chercher « Demander un congé » sous la liste. */}
      {!demandeOuverte && (
        <div className="flex justify-end">
          <button
            type="button"
            data-testid="espace-ouvrir-demande"
            onClick={() => setDemandeOuverte(true)}
            className="flex items-center gap-2 bg-[--color-primary] hover:bg-[--bg-hover] text-white px-4 py-2 rounded-lg shadow transition"
          >
            <FaPlus />
            <span>{t('espaceEmploye.demanderConge')}</span>
          </button>
        </div>
      )}

      {demandeOuverte && (
        <DemandeConge onDepot={() => setDemandesDeposees((n) => n + 1)} />
      )}

      {/* Même compteur que la liste : un dépôt fait bouger restant_projete
          aussi, car il compte les demandes en attente. */}
      <SoldeConges rafraichir={demandesDeposees} />

      <MesDemandes rafraichir={demandesDeposees} />
    </div>
  );
}

export default MesConges;
